import { Col, Form, FormCheck, Row } from "react-bootstrap";

const PlaylistsName = (
  programDetails,
  setProgramDetails,
  setFormEdited,
  isLocked
) => {
  return (
    <Form.Group controlId="nameInput">
      <Row className="align-items-center pt-2 ">
        <Form.Label
          column
          sm="2"
        >
          Name:
        </Form.Label>
        <Col>
          <Form.Control
            type="text"
            size="sm"
            value={programDetails.name.name}
            onChange={(e) => {
              setProgramDetails({
                ...programDetails,
                name: {
                  ...programDetails.name,
                  name: e.target.value,
                  isDirty: true,
                },
              });
              setFormEdited(true);
            }}
            className={programDetails.name.isDirty && "text-danger"}
            disabled={isLocked}
          />
        </Col>
        <Col sm="1">
          <FormCheck
            type="checkbox"
            isValid
            checked={programDetails.name.isDirty}
            disabled={isLocked}
            onChange={(e) => {
              setProgramDetails({
                ...programDetails,
                name: {
                  ...programDetails.name,
                  isDirty: e.target.checked,
                },
              });
              setFormEdited(true);
            }}
          />
        </Col>
      </Row>
    </Form.Group>
  );
};
export default PlaylistsName